export default "__VITE_ASSET__K2o76zMd__"